const shopCollections = [
  {
    icon: "ri-home-gear-line",
    title: "Home Backup Power",
    desc: "Keep your home running during outages with reliable systems built for real-world use.",
    href: "https://ironhavensupply.com/collections/home-backup-power",
    cta: "Shop Home Backup",
    accent: "text-amber-500",
    bg: "bg-amber-50",
    border: "border-amber-200",
    iconBg: "bg-amber-100",
  },
  {
    icon: "ri-sun-line",
    title: "Solar Generators",
    desc: "Portable, silent, and fuel-free power for homes, cabins, and emergencies.",
    href: "https://ironhavensupply.com/collections/solar-generators",
    cta: "Shop Solar Generators",
    accent: "text-emerald-600",
    bg: "bg-emerald-50",
    border: "border-emerald-200",
    iconBg: "bg-emerald-100",
  },
  {
    icon: "ri-landscape-line",
    title: "Off-Grid Systems",
    desc: "Complete energy independence for rural properties, shops, and long-term setups.",
    href: "https://ironhavensupply.com/collections/off-grid-power-systems",
    cta: "Explore Off-Grid Systems",
    accent: "text-stone-600",
    bg: "bg-stone-50",
    border: "border-stone-200",
    iconBg: "bg-stone-100",
  },
];

export default function ShopSection() {
  return (
    <section className="py-20 bg-gray-950 relative overflow-hidden">
      {/* Subtle background texture */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-amber-400 via-transparent to-transparent"></div>
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 bg-amber-500/10 border border-amber-500/30 text-amber-400 text-xs font-semibold px-4 py-1.5 rounded-full mb-4 uppercase tracking-widest">
            <i className="ri-store-2-line"></i>
            Shop Directly at IronHavenSupply.com
          </div>
          <h2 className="text-3xl md:text-4xl font-extrabold text-white">
            Shop Proven Backup Power Systems
          </h2>
          <p className="text-gray-400 mt-3 max-w-xl mx-auto text-base leading-relaxed">
            These are real systems homeowners are using today for backup power, off-grid living, and emergency preparedness.
          </p>
        </div>

        {/* 3 collection cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          {shopCollections.map((c) => (
            <a
              key={c.title}
              href={c.href}
              target="_blank"
              rel="noopener noreferrer"
              className={`group block bg-white rounded-lg border ${c.border} p-6 transition-all hover:-translate-y-1 cursor-pointer`}
            >
              <div className={`w-12 h-12 flex items-center justify-center ${c.iconBg} rounded-full mb-4`}>
                <i className={`${c.icon} ${c.accent} text-2xl`}></i>
              </div>
              <h3 className="font-bold text-gray-900 text-lg mb-2">{c.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed mb-4">{c.desc}</p>
              <span className={`inline-flex items-center gap-1.5 font-semibold text-sm ${c.accent} group-hover:underline whitespace-nowrap`}>
                {c.cta}
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-external-link-line text-xs"></i>
                </div>
              </span>
            </a>
          ))}
        </div>

        {/* Bottom CTA buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://ironhavensupply.com/collections"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-amber-500 hover:bg-amber-400 text-white font-bold px-8 py-3.5 rounded-md text-sm transition-colors cursor-pointer whitespace-nowrap"
          >
            Shop All Systems
          </a>
          <a
            href="https://ironhavensupply.com/collections/solar-generators"
            target="_blank"
            rel="noopener noreferrer"
            className="border border-gray-600 hover:border-amber-500 hover:text-amber-400 text-gray-300 font-semibold px-8 py-3.5 rounded-md text-sm transition-colors cursor-pointer whitespace-nowrap"
          >
            Compare Solar Generators
          </a>
          <a
            href="https://ironhavensupply.com/collections/home-backup-power"
            target="_blank"
            rel="noopener noreferrer"
            className="border border-gray-600 hover:border-amber-500 hover:text-amber-400 text-gray-300 font-semibold px-8 py-3.5 rounded-md text-sm transition-colors cursor-pointer whitespace-nowrap"
          >
            View Whole Home Systems
          </a>
        </div>
      </div>
    </section>
  );
}
